import RemoteFile from '@/helper/RemoteFile';
import React from 'react';
import { Icons } from '@/icons';

export interface Game {
  id: string;
  title: string;
  image_url: string;
  file_url: string;
}

interface Props {
  games: Game[];
  selectedId: string;
  onSelect: (id: string) => void;
}

export const GameSelector: React.FC<Props> = ({
  games,
  selectedId,
  onSelect,
}) => (
  <details className="group rounded-xl bg-[#F5F5F5] p-4">
  {/* Header / Summary */}
  <summary className="flex items-center justify-between bg-[#F5F5F5] text-lg font-medium cursor-pointer">
    <span className='font-normal text-base'>Select Gamic</span>
    <span className="transform rotate-180 transition-transform duration-200 group-open:rotate-0 mr-4">
      <Icons.ChivronUp />
    </span>
  </summary>

    {/* Divider line */}
    <hr className="my-4 border-t border-gray-400" />

    {/* Options */}
    <ul className="space-y-2 bg-[#F5F5F5] max-h-[300px] overflow-auto">
      {games.map((g) => (
        <li
          key={g.id}
          className="flex items-center gap-5 pl-3 py-[6px] bg-white rounded-xl"
        >
          {/* Radio */}
          <input
            type="radio"
            name="game"
            className="w-5 h-5 accent-black"
            checked={selectedId === g.id}
            onChange={() => onSelect(g.id)}
          />

          {/* Game Image */}
          <RemoteFile
            className="h-10 object-cover rounded-[5px]"
            keyPath={g.image_url}
            key={g.title}
          />

          {/* Title */}
          <span className="text-gray-900 text-base">{g.title}</span>
        </li>
      ))}
    </ul>
  </details>
);

